/**
 * AUDIO — footstep cadence derived from player:moved events. Accumulates
 * horizontal distance and fires once per stride; large jumps are treated as
 * teleports and reset the tracker. Owned by AUDIO; see CONTRACTS.md.
 */
import type { Vec3 } from '../core/types'
import { STEP_DISTANCE_M, STEP_TELEPORT_DISTANCE_M } from './constants'

export type FootstepTracker = (position: Vec3) => void

export const createFootstepTracker = (onStep: () => void): FootstepTracker => {
  let last: Vec3 | null = null
  let traveled = 0

  return (position: Vec3): void => {
    if (!last) {
      last = position
      return
    }
    const dx = position.x - last.x
    const dz = position.z - last.z
    const distance = Math.hypot(dx, dz)
    last = position

    if (distance > STEP_TELEPORT_DISTANCE_M) {
      traveled = 0
      return
    }

    traveled += distance
    if (traveled >= STEP_DISTANCE_M) {
      traveled -= STEP_DISTANCE_M
      onStep()
    }
  }
}
